export default __webpack_public_path__ + "static/media/elephant_wating.cc47ea07.png";